module.exports = __webpack_public_path__ + "static/img/vendormain.f9804c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/vendormain.png
// module id = PWA8
// module chunks = 0